import { render, staticRenderFns } from "./StudioService.vue?vue&type=template&id=23573405"
import script from "./StudioService.vue?vue&type=script&lang=js"
export * from "./StudioService.vue?vue&type=script&lang=js"
import style0 from "./StudioService.vue?vue&type=style&index=0&id=23573405&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports